import Button from "@/components/Form/Button/Button";
import {
  MotifErrorMessage,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useEffect, useState,useContext } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ControlSelect from "./SelectBox/editFieldSelectBox";
import ControlInputBoxNumber from "@/components/Form/InputBox/ControlInputBoxNumber";
import ControlCheckBox from "./Checkbox";
import { renderOptionList } from "../Form/calculationSummaryHelper";
import {
  useCreateLimitAmountMutation,
  useGetDistributionApiDataQuery,
  useGetListCalculationStepQuery,
} from "../calculationStepReducer";
import { useGetDistributionWithSameSequenceIdQuery } from "@/services/distribution/distributionReducers";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { CANCEL_BUTTON_VARIANT, SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import FutureReferencingLogic from "../Form/FutureReferencingLogic";
import { capitalizeWordsInSentence } from "@/utility/common";
import { isNumericOrNull } from "@/utility/validation";
import { useParams } from "react-router-dom";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { DistributionStepContext } from "../../summery/DistributionContext";

export default function LimitAmountFormNew({
  caseId,
  stepId,
  createShow,
  setCreateShow,
  refetch,
  manualDataSource,
}: any) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
    setError,
    formState: { errors, isDirty },
  } = useForm<any>({
    defaultValues:{
      type: "",
      dataSource: "",
      entitleMentSet: "",
      manualDataSource: "",
      futureReferencingLogic: "",
      distribution: "",
      calculationStep: "",
      weightingFactor: "",
      filterApplicableClasses: false,
    }
  });
  const [isFrenchSelected, setIsFrenchSelected] = useState(false);
  let defaultOption = {
    label: t("global.globalActions.optionDefault"),
    value: "",
  };
  const checkBoxHandler = (e?: React.ReactEventHandler) => {
    setIsFrenchSelected(!isFrenchSelected);
  };
  const resetData = {
    limitType: "",
    isZeroLimit: "",
    dataSourceType: "",
    isEntitlement: false,
    isFilterApplicableClasses: false,
    weight: "",
    sourceCalculationStepId: "",
    sourceManualDataSourceId: "",
  };
  const { data: distribution } = useGetDistributionApiDataQuery(caseId);
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const [isDistributionSeq, setIsDistributionSeq] = useState(false);
  const distributionStepContextData: any = useContext<any>(DistributionStepContext);
  const [createLimitAmount] = useCreateLimitAmountMutation();
  const distributionId = watch("distribution");
  const { data: calculationStep ,isFetching:stepCaluclationFetching} = useGetListCalculationStepQuery(
    {
      distributionId: distributionId,
      pageSize: 10000,
      SortColumn: "SortOrder",
    },
    { skip: !distributionId }
  );
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const { distributionId: currentDistributionId } = useParams<{
    distributionId: string;
  }>();
  let filterStepData = [];
  const calculationStepData = calculationStep?.results
    ? calculationStep.results
    : [];
  if (calculationStepData.length === 0) {
  } else if (distributionId !== currentDistributionId) {
    filterStepData = calculationStepData;
  } else {
    const index = calculationStepData.findIndex(
      (step: any) => step.id === stepId
    );
    filterStepData = calculationStepData.slice(0, index);
  }
  const { data: distributionWithSequence,isFetching:isDistributionSequenceFetching } = useGetDistributionWithSameSequenceIdQuery(currentDistributionId,{ skip: !currentDistributionId });


  const getDataSource = watch("dataSource");
  const manualDataSourceList = renderOptionList(
    manualDataSource,
    "name",
    "id",
    defaultOption
  );
  const futureReferencingLogicValue = watch("futureReferencingLogic");
  let selectedDistribution = distribution?.results?.find((item: any) => {
    return item.id === currentDistributionId});
  
  const currentDistributionYear = selectedDistribution && selectedDistribution !== undefined ? new Date(
    //@ts-ignore
    selectedDistribution?.distributionDate
  ).getFullYear() : null;
  const filteredDistributionList = distribution?.results?.filter(
    (item: any) => {
      if (futureReferencingLogicValue && futureReferencingLogicValue === "1") {
        const distributionYear = item?.distributionDate !== null ?  new Date(item.distributionDate).getFullYear() : null;
        if (distributionYear && currentDistributionYear !== null && distributionYear < currentDistributionYear) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
  );

  const currentDistributionSeqYear = distributionStepContextData.currentDistributionYear;
  const filteredDistributionListSeq = distributionWithSequence?.results?.filter(
    (item: any) => {
      if (futureReferencingLogicValue && futureReferencingLogicValue === "1") {
        const distributionYear = item?.distributionDate !== null ?  new Date(item.distributionDate).getFullYear() : null;
        if (distributionYear && currentDistributionSeqYear !== null && distributionYear < currentDistributionSeqYear) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
  );

  const distributionListSeq = renderOptionList(
    filteredDistributionListSeq,
    "name",
    "id",
    defaultOption
  );
  const distributionList = renderOptionList(
    filteredDistributionList,
    "name",
    "id",
    defaultOption
  );

  function handleFutureReferencingLogicChange(value: any) {
    setValue("distribution", "");
    if (value === "1" || value === "0") {
      setIsDistributionSeq(true);
    }
    else{
      setIsDistributionSeq(false);
    }
  }

  const calculationStepList = renderOptionList(
    filterStepData,
    "name",
    "id",
    defaultOption
  );

  const errorList = Object.keys(errors);
  const errorsShow = capitalizeWordsInSentence(errorList.join(", "));

  const onSubmit = async (data: any) => {
    let inputValue = data?.weightingFactor;
    if (!(inputValue <= 0 || inputValue >= 0)) {
      // Optionally handle the case where the input is not numeric
      setError("weightingFactor", {
        type: "manual",
        message: "notNumeric",
      });
      return;
    }
    let formData: any = {
      caseId: caseId,
      calculationStepId: stepId,
      limitType: Number(data?.type),
      dataSourceType: Number(data?.dataSource),
      isEntitlement: data?.entitleMentSet === "0" ? true : false,
      isFilterApplicableClasses: data?.filterApplicableClasses || false,
      weight: Number(data?.weightingFactor),
      sourceCalculationStepId: data?.dataSource === "1" && data?.calculationStep ? data?.calculationStep : null,
      sourceManualDataSourceId:  data?.dataSource === "2" && data?.manualDataSource ? data?.manualDataSource : null,
      referenceLogic:
        Number(data?.futureReferencingLogic) === 0
          ? 0
          : Number(data?.futureReferencingLogic) || null,
    };

    setIsLoading(true);
    const response = await createLimitAmount(formData);
    if (response.hasOwnProperty("data")) {
      setCreateShow(false);
      setIsLoading(false);
      refetch();
      reset(resetData);
    } else {
      //@ts-ignore
      const error = response.error?.data?.message || t("global.globalNotifications.unExpectedError");
      setShowMessage({
        ...showMessage,
        show: true,
        type: "error",
        message: error,
      });
      setIsLoading(false);
    }
  };
  const dataSources = watch("dataSource");
  const entitleMentSet = watch("entitleMentSept");

  useEffect(() => {
    if (dataSources === "1" && entitleMentSet === undefined) {
      setValue("entitleMentSet", "0");
    }
    if(dataSources !== "1"){
      setIsDistributionSeq(false);
      setValue("futureReferencingLogic", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSources]);

  const selectedDistributionId = watch("distribution");

  useEffect(() => {
    if (selectedDistributionId !== undefined ) {
      
      setValue("calculationStep", "");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ selectedDistributionId, setValue]);
  const distributionOptionList = isDistributionSeq ? distributionListSeq : distributionList;

  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    reset(resetData);
    setCreateShow(false);
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  return (
    <>
      <MotifModal
        onClose={() => {
          if(isDirty){
            setIsVisibleCancel(true);
          }
          else{
            setCreateShow(false);
          }
        }}
        show={createShow}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
        size={"xl"}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formModalWrapper">
            <MotifModalHeader>
              <span className="discard_heading">
                {t(
                  "pages.distributions.distributionStepsTab.limitAmountTab.limitFormCreate.title"
                )}
              </span>
            </MotifModalHeader>
            <MotifModalBody style={{ minHeight: "300px" }}>
              <div className="formModal">
              {
              showMessage.show && showMessage.type === "error" && ( <NotificationGrid show={showMessage.show} message={showMessage.message} type={showMessage.type} />)
            }
                <div className="motif-row">
                  <div className="motif-col-sm-12 motif-col-md-4 motif-col-lg-4">
                    <ControlSelect
                      name={"type"}
                      //@ts-ignore
                      control={control}
                      required={true}
                      showLabel={true}
                      readonly={true}
                      label={
                        "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.type"
                      }
                      //@ts-ignore
                      placeholder={"placeholder"}
                      options={[
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.typeOptions.label"
                          ),
                          value: "",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.typeOptions.label1"
                          ),
                          value: "0",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.typeOptions.label2"
                          ),
                          value: "1",
                        },
                      ]}
                    />
                    {errors["type"] && errors["type"].type === "required" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.typeRequired"
                        )}
                      </MotifErrorMessage>
                    )}
                  </div>
                  <div className="motif-col-sm-12 motif-col-md-4 motif-col-lg-4">
                    <ControlSelect
                      name={"dataSource"}
                      //@ts-ignore
                      control={control}
                      required={true}
                      showLabel={true}
                      readonly={true}
                      label={
                        "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.datasource"
                      }
                      disabled={false}
                      //@ts-ignore
                      placeholder={"placeholder"}
                      options={[
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label1"
                          ),
                          value: "",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label2"
                          ),
                          value: "0",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label3"
                          ),
                          value: "1",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label4"
                          ),
                          value: "2",
                        },
                      ]}
                    />
                    {errors["dataSource"] &&
                      errors["dataSource"].type === "required" && (
                        <MotifErrorMessage>
                          {t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.dataSourceRequired"
                          )}
                        </MotifErrorMessage>
                      )}
                  </div>
                  {getDataSource === "1" && (
                    <div className="motif-col-sm-12 motif-col-md-4 motif-col-lg-4">
                      <ControlSelect
                        name={"entitleMentSet"}
                        //@ts-ignore
                        control={control}
                        required={true}
                        showLabel={true}
                        readonly={true}
                        label={
                          "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.entitlement"
                        }
                        //@ts-ignore
                        placeholder={"placeholder"}
                        options={[
                          {
                            label: t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.entitlementOptions.label1"
                            ),
                            value: "",
                          },
                          {
                            label: t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.entitlementOptions.label2"
                            ),
                            value: "0",
                          },
                          {
                            label: t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.entitlementOptions.label3"
                            ),
                            value: "1",
                          },
                        ]}
                      />
                      {errors["entitleMentSet"] &&
                        errors["entitleMentSet"].type === "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.entitlementRequired"
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  )}

                  {getDataSource === "2" && (
                    <div className="motif-col-sm-12 motif-col-md-4 motif-col-lg-4">
                      <ControlSelect
                        name={"manualDataSource"}
                        //@ts-ignore
                        control={control}
                        required={true}
                        showLabel={true}
                        readonly={true}
                        disabled={false}
                        label={
                          "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.manualDataSource"
                        }
                        //@ts-ignore
                        placeholder={"placeholder"}
                        options={manualDataSourceList}
                      />
                      {errors["manualDataSource"] &&
                        errors["manualDataSource"].type === "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.manualDataSourceRequired"
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  )}
                </div>

                {getDataSource === "1" && (
                  <div className="motif-row">
                    <div
                      className="motif-col-sm-12 motif-col-md-8 motif-col-lg-8"
                      style={getDataSource === "1" ? { marginTop: "20px" } : {}}
                    >
                      <FutureReferencingLogic
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                        selectedId={null}
                        handleChange={handleFutureReferencingLogicChange}
                      />
                      {errors["futureReferencingLogic"] &&
                        errors["futureReferencingLogic"].type ===
                          "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.dataSourceTab.validationMessages.futureReferencingLogicReq",
                              { fieldNames: errorsShow }
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  </div>
                )}
                <div >
                  {getDataSource === "1" && (
                    <>
                    <div className="motif-row ">
                      <div
                        className="motif-col-sm-12 motif-col-md-8 motif-col-lg-8"
                        style={{ marginTop: "20px" }}
                      >
                        <ControlSelect
                          name={"distribution"}
                          //@ts-ignore
                          control={control}
                          required={true}
                          showLabel={true}
                          readonly={true}
                          label={
                            "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.distribution"
                          }
                          //@ts-ignore
                          placeholder={"placeholder"}
                          options={distributionOptionList}
                          disabled={false}
                        />
                        {errors["distribution"] &&
                          errors["distribution"].type === "required" && (
                            <MotifErrorMessage>
                              {t(
                                "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.distributionRequired"
                              )}
                            </MotifErrorMessage>
                          )}
                      </div>
                      {isDistributionSequenceFetching && <MotifProgressLoader className="align-self-center mar-t-20" variant="circular" size="xs" ></MotifProgressLoader>}
                      </div>
                      <div className="motif-row ">
                      <div
                        className="motif-col-sm-12 motif-col-md-8 motif-col-lg-8"
                        style={{ marginTop: "20px" }}
                      >
                        <ControlSelect
                          name={"calculationStep"}
                          //@ts-ignore
                          control={control}
                          required={true}
                          showLabel={true}
                          readonly={true}
                          label={
                            "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.calculationStep"
                          }
                          filter={true}
                          disabled={stepCaluclationFetching}
                          //@ts-ignore
                          placeholder={"placeholder"}
                          options={calculationStepList}
                        />
                        {errors["calculationStep"] &&
                          errors["calculationStep"].type === "required" && (
                            <MotifErrorMessage>
                              {t(
                                "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.caluclationStepRequired"
                              )}
                            </MotifErrorMessage>
                          )}
                          {/* <MotifProgressLoader variant="circular"></MotifProgressLoader> */}
                      </div>
                       {stepCaluclationFetching && <MotifProgressLoader className="align-self-center mar-t-40" variant="circular" size="xs" ></MotifProgressLoader>}
                      
                      </div>
                    </>
                  )}
                </div>
                <div className="motif-row">
                  <div
                    className="motif-col-sm-12 motif-col-md-4 motif-col-lg-4"
                    style={{ marginTop: "20px" }}
                  >
                    <ControlInputBoxNumber
                      name={"weightingFactor"}
                      // @ts-ignore
                      control={control}
                      required={true}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.weightingFactor"
                      }
                      showLabel={true}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {}}
                      validate={isNumericOrNull}
                      // validate={isNumeric}
                    />
                    {errors["weightingFactor"] &&
                      errors["weightingFactor"].type === "required" && (
                        <MotifErrorMessage>
                          {t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.weighingRequired"
                          )}
                        </MotifErrorMessage>
                      )}
                    {errors["weightingFactor"]?.type === "validate" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.weighingNumericRequired"
                        )}
                      </MotifErrorMessage>
                    )}
                  </div>
                </div>
                <div className="motif-row">
                  <div
                    className="motif-col-sm-12 motif-col-md-12 motif-col-lg-4 pad-t-10"
                    style={{ alignSelf: "center" }}
                  >
                    <div style={{ position: "relative", top: "10px" }}>
                      <ControlCheckBox
                        id="checkbox-french-selection"
                        onChange={checkBoxHandler}
                        checked={isFrenchSelected}
                        value={isFrenchSelected}
                        name={"filterApplicableClasses"}
                        control={control}
                        required={false}
                        label={t(
                          "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.applicable"
                        )}
                        setIsFrenchSelected={setIsFrenchSelected}
                      />
                      {errors["filterApplicableClasses"] &&
                        errors["filterApplicableClasses"].type ===
                          "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.applicableRequired"
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </MotifModalBody>
            <MotifModalFooter>
              <div className="button-container-add">
                <Button
                  variant={SAVE_BUTTON_VARIANT}
                  loading={isLoading}
                  label={t("global.globalActions.save")}
                  disabled={isLoading}
                />
                <Button
                  label={t("global.globalActions.cancel")}
                  type="button"
                  variant={CANCEL_BUTTON_VARIANT}
                  className="cancelBtn"
                  onClickHandler={() => {
                    if(isDirty){
                      setIsVisibleCancel(true);
                    }
                    else{
                      setCreateShow(false);
                      setIsVisibleCancel(false);
                    }
                  }}
                />
              </div>
            </MotifModalFooter>
          </div>
        </form>
      </MotifModal>
      <ConfirmationModal
        isVisible={isVisibleCancel}
        setIsVisible={setIsVisibleCancel}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </>
  );
}
